import ClipboardPasteEventHandler from "../../js/util/ClipboardPasteEventHandler.js";

export default class StructureUploadAreaHtml {
	/** @type {HTMLElement} */
	#root;
	/** @type {Function} */
	#onUploadCb;

	/** @param {Function} onUploadCb */
	constructor(onUploadCb) {
		if(typeof onUploadCb !== 'function')
			throw new Error("A callback is required to handle file upload events. Actually passed: " + onUploadCb);
		this.#onUploadCb = onUploadCb;
	}

	/** @param {HTMLElement} parent */
	init(parent) {
		parent.insertAdjacentHTML('beforeend', this.#htmlTemplate());
		this.#root = parent.lastElementChild;
		this.#initListeners();
	}

	#initListeners() {
		this.#getFileUploadInput().addEventListener("change", async (evt) => {
			this.#onUploadCb(evt.target.files);
			// w/o clearing the value, Chrome will not dispatch again for the 2nd time:
			// https://stackoverflow.com/a/11280934
			evt.target.value = '';
		});
		const clipboardPasteHandler = new ClipboardPasteEventHandler();
		clipboardPasteHandler.init(this.#root);
		clipboardPasteHandler.onPasteAsFile(this.#onUploadCb);
	}

	#getFileUploadInput() {
		return this.#root.querySelector('#upload-file-input');
	}
	/**
	 * @param {string} message
	 * @param {string} icon
	 * @returns {string}
	 * @private
	 */
	#htmlTemplate(message, icon) {
		return `<div class="file-drop-area" tabindex="1">
                  <label class="visually-hidden"><input type="file" id="upload-file-input"/></label>
                  <div class="file-drop-area__text">
                    <p>Drop, paste or <label class="link" for="upload-file-input">browse</label></p>
                    <p>column of SMILES or InChI</p>
                    <p>or MOL/SDF</p>
                  </div>
              	</div>`;
	}
}